import { GlAnimatedLoaderIcon, GlAvatar, GlAvatarLink } from '@gitlab/ui';
import { mapState } from 'pinia';
import SafeHtml from '~/vue_shared/directives/safe_html';
import TimelineEntryItem from '~/vue_shared/components/notes/timeline_entry_item.vue';
import NoteHeader from '~/notes/components/note_header.vue';
import { useNotes } from '~/notes/store/legacy_notes';
export default {
    name: 'DuoCodeReviewSystemNote',
    directives: {
        SafeHtml
    },
    components: {
        GlAnimatedLoaderIcon,
        GlAvatar,
        GlAvatarLink,
        TimelineEntryItem,
        NoteHeader
    },
    props: {
        note: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapState(useNotes, [
            'targetNoteHash'
        ]),
        noteAnchorId () {
            return `note_${this.note.id}`;
        },
        isTargetNote () {
            return this.targetNoteHash === this.noteAnchorId;
        },
        isInProgress () {
            // duo_session_status is a snapshot from when the note was created, when the
            // workflow is usually still `created` (enqueued), so both `created` and
            // `running` count as in-progress. A missing status keeps the spinner for
            // notes created before this field existed.
            const status = this.note.duo_session_status;
            return status === undefined || status === null || status === 'running' || status === 'created';
        }
    }
};
